import { PacketTypes } from "./types";
import {
  WantJoinPacket,
  PlayerWantJoinPacket,
  JoinResponsePacket,
  GameserverPacket,
  LobbyUpdatePacket,
  PlayerPacket,
  ServerStatePacket,
  PlayerMovePacket,
  ClientMovePacket,
  PingPacket,
  PongPacket,
  PlayerLinesPacket,
  ClientLinesPacket,
  PlayerLeavePacket,
  ChatMessagePacket,
  GameStartPacket,
  GamePausePacket,
  ClientPausePacket,
  PlayerStatePacket,
  GameOverPacket,
  ClientDeadPacket,
  DeadPacket,
  ClientStatePacket,
  ClientRespawnPacket,
  RespawnPacket,
  ChangeTeamPacket,
  StampBlockPacket,
  ClientStampBlockPacket,
  GonePacket,
  ClientGonePacket,
  RemoveBonusPacket,
  ClientRemoveBonusPacket,
  FirstFragPacket,
  ClientFirstFragPacket,
  DownloadStatePacket,
  PlayerStatsPacket,
  RejoinPacket,
  ClientStartWatchPacket,
  ServerRandomPacket,
  EndgamePacket,
  PlayerCanvasStatePacket,
  GameMessagePacket,
  GameSettingsPacket,
  Packet,
} from "./packets";

export class PacketFactory {
  public static create(packetId: number): Packet | null {
    switch (packetId) {
      case PacketTypes.WANT_JOIN:
        return new WantJoinPacket();
      case PacketTypes.JOIN_REQUEST:
        return new PlayerWantJoinPacket();
      case PacketTypes.JOIN_RESPONSE:
        return new JoinResponsePacket();
      case PacketTypes.GAMESERVER:
        return new GameserverPacket();
      case PacketTypes.LOBBY_UPDATE:
        return new LobbyUpdatePacket();
      case PacketTypes.PLAYER:
        return new PlayerPacket();
      case PacketTypes.SERVER_STATE:
        return new ServerStatePacket();
      case PacketTypes.PLAYER_MOVE:
        return new PlayerMovePacket();
      case PacketTypes.CLIENT_MOVE:
        return new ClientMovePacket();
      case PacketTypes.PING:
        return new PingPacket();
      case PacketTypes.PONG:
        return new PongPacket();
      case PacketTypes.PLAYER_LINES:
        return new PlayerLinesPacket();
      case PacketTypes.CLIENT_LINES:
        return new ClientLinesPacket();
      case PacketTypes.PLAYER_LEAVE:
        return new PlayerLeavePacket();
      case PacketTypes.CHAT_MESSAGE:
        return new ChatMessagePacket();
      case PacketTypes.GAME_START:
        return new GameStartPacket();
      case PacketTypes.GAME_PAUSE:
        return new GamePausePacket();
      case PacketTypes.CLIENT_PAUSE:
        return new ClientPausePacket();
      case PacketTypes.PLAYER_STATE:
        return new PlayerStatePacket();
      case PacketTypes.GAME_OVER:
        return new GameOverPacket();
      case PacketTypes.CLIENT_DEAD:
        return new ClientDeadPacket();
      case PacketTypes.DEAD:
        return new DeadPacket();
      case PacketTypes.CLIENT_STATE:
        return new ClientStatePacket();
      case PacketTypes.CLIENT_RESPAWN:
        return new ClientRespawnPacket();
      case PacketTypes.RESPAWN:
        return new RespawnPacket();
      case PacketTypes.CHANGE_TEAM:
        return new ChangeTeamPacket();
      case PacketTypes.STAMP_BLOCK:
        return new StampBlockPacket();
      case PacketTypes.CLIENT_STAMP_BLOCK:
        return new ClientStampBlockPacket();
      case PacketTypes.GONE:
        return new GonePacket();
      case PacketTypes.CLIENT_GONE:
        return new ClientGonePacket();
      case PacketTypes.REMOVE_BONUS:
        return new RemoveBonusPacket();
      case PacketTypes.CLIENT_REMOVE_BONUS:
        return new ClientRemoveBonusPacket();
      case PacketTypes.FIRST_FRAG:
        return new FirstFragPacket();
      case PacketTypes.CLIENT_FIRST_FRAG:
        return new ClientFirstFragPacket();
      case PacketTypes.DOWNLOAD_STATE:
        return new DownloadStatePacket();
      case PacketTypes.PLAYER_STATS:
        return new PlayerStatsPacket();
      case PacketTypes.REJOIN:
        return new RejoinPacket();
      case PacketTypes.CLIENT_START_WATCH:
        return new ClientStartWatchPacket();
      case PacketTypes.SERVER_RANDOM:
        return new ServerRandomPacket();
      case PacketTypes.ENDGAME:
        return new EndgamePacket();
      case PacketTypes.PLAYER_CANVAS_STATE:
        return new PlayerCanvasStatePacket();
      case PacketTypes.GAME_MESSAGE:
        return new GameMessagePacket();
      case PacketTypes.GAME_SETTINGS:
        return new GameSettingsPacket();
      default:
        console.warn(`[PacketFactory] Unknown packet type: ${packetId}`);
        return null;
    }
  }
}

